import React, { Component } from 'react';
import Cards from '../../components/cards/Cards';

class EmbedGrid extends Component {
    constructor(props) {
        super(props);
        this.state = { loading:false,cards:[], }
    }

    componentDidMount()
    {
        const city = this.props.location.pathname.split("/")[3];
        this._callAPI(city);
    }

    _callAPI = (city) => {
        if (this.state.city === "") return;
        this.setState({ loading: true });
        let url = `https://hearrealtors.herokuapp.com/grid?city=${city}`;
        fetch(url)
          .then((response) => response.json())
          .then((data) => {
            this.setState({
              loading: false,
              cards: data,
              searchErrorMsg: "",
            });
            // console.log(data);
        })
        .catch((err) => {
            this.setState({
              loading: false,
              searchErrorMsg: "No results Founds",
            });
            console.log(err);
        });
      };
    render() { 
        return (     
            <Cards list={this.state.cards} loading={this.state.loading}   />   
        );
    }
}
 
export default EmbedGrid;